import React, { useMemo } from 'react';
import { Input as AntdInput } from 'antd';

import styles from './LabeledInput.module.scss';

export const LabeledTextArea = React.forwardRef(({ label, disabled, withAsterisks, ...props }, ref) => {
  const hasAsterisks = useMemo(() => {
    if (withAsterisks === false) { return false; }

    return withAsterisks || (
      props['data-__meta'] && props['data-__meta'].rules
            && props['data-__meta'].rules.some(item => item.required === true)
    );
  }, [ props ]);

  return (
    <div ref={ ref } className={ styles.inputWrapper }>
      <label className={ styles.label } style={ disabled ? { color: '#999', zIndex: '999' } : { color: '#57a7d7' } }>
        {`${label}`}
        {hasAsterisks && <span className={ styles.asterisks }>{' *'}</span>}
      </label>
      <div className={ styles.inputField }>
        <AntdInput.TextArea
          style={ styles }
          disabled={ disabled }
          className={ disabled ? styles.isDisabled : '' }
          { ...props }
        />
      </div>
    </div>
  );
});
